import { render, staticRenderFns } from "./manager.vue?vue&type=template&id=2ed93bb2&scoped=true&"
import script from "./manager.vue?vue&type=script&lang=ts&"
export * from "./manager.vue?vue&type=script&lang=ts&"
import style0 from "./manager.vue?vue&type=style&index=0&id=2ed93bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed93bb2",
  null
  
)

export default component.exports